import { useEffect, useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import methods from '../../services/utility';
import { toast } from 'react-toastify';

const SnappPushData = ({
  open,
  closeSnappCallerModal,
  selectMerchant,
  snappOrders,
  resetSnappCallers,
  createNewMerchant,
  cashDeskId
}) => {
  const [showNotifBox, setShowNotifBox] = useState(open);
  const navigate = useNavigate();
  const { branchId } = useParams();

  useEffect(() => {
    setShowNotifBox(open);
    if (!open) {
      resetSnappCallers();
    }
    // console.log('snappOrders', snappOrders)
  }, [open, resetSnappCallers]);

  // const selectCaller = (item) => {
  //   // console.log('item', item)
  //   const mappedItem = {
  //     ...item,
  //     mobile: item.merchantPhone || "",
  //     firstName: item.merchantName || "",
  //     lastName: "",
  //   };
  //   // console.log(mappedItem)
  //   selectMerchant(mappedItem, item.addresses, item.userId);
  //   setShowNotifBox(false);
  //   closeSnappCallerModal();
  // };

  // const selectToCreateNewMerchant = (item) => {
  //   const mappedItem = {
  //     ...item,
  //     firstName: "",
  //     lastName: "",
  //     mobile: item.merchantPhone,
  //   };
  //   // console.log(mappedItem)
  //   // selectMerchant(mappedItem, item.addresses, item.userId);
  //   setShowNotifBox(false);
  //   closeSnappCallerModal();
  //   createNewMerchant(mappedItem);
  // }

  const seeOrders = (cashDeskId) => {
    if (!cashDeskId || cashDeskId === 0 || cashDeskId === '0') {
      toast.error('ابتدا صندوق را انتخاب کنید.', {
        position: "top-right",
        autoClose: 1000,
        theme: "colored",
        style: {
          backgroundColor: "#FBE7E7",
          color: "#D00707"
        },
        progressClassName: "progressBarColor",
      });
    } else {
      navigate(`/sale/${branchId}/snappManager/Orders/${cashDeskId}`);
    }
  };

  const renderNotification = () => (
    <div className="modal fade show" tabIndex="-1" role="dialog" style={{ display: showNotifBox ? 'block' : 'none' }}>
      <div className="modal-dialog modal-lg" role="document">
        <div className="modal-content px-3">
          <div className="modal-header">
            <h5 className="modal-title">تماس‌های اسنپ</h5>
            <button
              type="button"
              className="btn-close"
              data-bs-dismiss="modal"
              aria-label="Close"
              onClick={() => { setShowNotifBox(false); closeSnappCallerModal(); }}
            ></button>
          </div>
          <div className="modal-body">
            {snappOrders.map((item, index) => (
              <div className='border border-1 rounded-2 p-3 mb-3 shadow card' key={index}>
                <div className='row g-3'>
                  <div className='col-md-6 col-lg-3'>
                    {item.merchantName}
                  </div>
                  <div className='col-md-6 col-lg-3'>
                    موبایل: {methods.formatPhoneNumber(item.merchantPhone)}
                  </div>
                  <div className='col-md-6 col-lg-8'>
                    {item.address}
                  </div>
                  <div className='col-md-6 col-lg-4 text-end mt-1'>
                    <button className='btn btn-purple btn-sm' onClick={() => seeOrders(cashDeskId)}>مشاهده سفارش</button>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );

  return (
    <>
      {renderNotification()}
    </>
  );
}

export default SnappPushData;